/*
 * @Author: 李朋飞
 * @Date: 2022-07-12 09:10:33
 * @LastEditTime: 2024-05-07 11:38:02
 * @Description: 
 */
import Score from './Score';

export default {
  install(Vue) {
    Vue.component('Score', Score);
  }
};


// WEBPACK FOOTER //
// ./src/components/Score/index.js